export default __webpack_public_path__ + "static/media/AnimalMagic_03.4f152540.png";